const POLICYTYPE = {
  PORTFOLIO_MANAGEMENT: 'urn:replicon:policy:portfolio-management',
  PROJECT_MANAGEMENT: 'urn:replicon:policy:project-management',
  REVENUE_MANAGEMENT: 'urn:replicon:policy:revenue-management',
  RESOURCE_MANAGEMENT: 'urn:replicon:policy:resource-management'
};

export default POLICYTYPE;
